import { useCallback } from 'react';
import { useAudioSettings } from './useAudioSettings';

let clickAudio: HTMLAudioElement | null = null;

function playClickSound(volume: number = 0.3) {
  try {
    if (!clickAudio) {
      clickAudio = new Audio('/soundeffects/click.mp3');
    }
    
    // Clone the audio to allow overlapping sounds
    const audio = clickAudio.cloneNode() as HTMLAudioElement;
    audio.volume = volume;
    
    // Play only first 500ms
    audio.play();
    setTimeout(() => {
      audio.pause();
      audio.currentTime = 0;
    }, 500);
  } catch (err) {
    // Silently fail if audio can't play
    console.debug('Could not play click sound:', err);
  }
}

export function useClickSound() {
  const audioSettings = useAudioSettings();
  
  // Wrapper function that adds click sound to any handler
  const withClickSound = useCallback(<T extends (...args: any[]) => void>(handler: T): T => {
    return ((...args: any[]) => {
      playClickSound(audioSettings.effectiveSoundEffectsVolume);
      handler(...args);
    }) as T;
  }, [audioSettings.effectiveSoundEffectsVolume]);

  // Direct function to play click sound
  const playClick = useCallback(() => {
    playClickSound(audioSettings.effectiveSoundEffectsVolume);
  }, [audioSettings.effectiveSoundEffectsVolume]);

  return { withClickSound, playClickSound: playClick };
}
